import { SalePaymentController as controller } from './sale-payment.controller'
import template from './sale-payment.html'

export const SalePaymentComponent = {
  controller,
  template,
}
